module.exports = __webpack_public_path__ + "img/get-the-power.70ca570c.png";